import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getCookie } from '../utils/get-cookie';

@Injectable({
  providedIn: 'root',
})
export class TechfinanceService {
  token: string = '';
  constructor(public http: HttpClient) {
    this.token = getCookie('token');
  }

  getClients(page: number = 0, max: number = 5, search: string = ''): Observable<any> {
    const url = `${environment.api_techfinance}users/member?page=${page}&max=${max}&search=${encodeURIComponent(search)}`;
  
    return this.http.get(url, {
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
    });
  }

  getGuiaStudies(clientExternalId: string, routeParam?: string) {
    if (routeParam === 'estudo-pessoal') {
      return this.http.get(`${environment.api_guia}studies/personal`, {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      });
    }
    return this.http.get(`${environment.api_guia}studies/${clientExternalId}`, {
      headers: {
        Authorization: 'Bearer ' + this.token,
      },
    });
  }

  getEspecificUser(id: string) {
    return this.http.get(`${environment.api_techfinance}users/member/${id}`, {
      headers: {
        Authorization: 'Bearer ' + this.token,
      },
    });
  }

  createStudy(client_id: string, routeParam?: string){
    if (routeParam === 'estudo-pessoal') {
      return this.http.post(`${environment.api_guia}studies/personal`, {}, {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      })  
    }
    return this.http.post(`${environment.api_guia}studies/${client_id}`, {}, {
      headers: {
        Authorization: 'Bearer ' + this.token,
      },
    })
  }

  updateGuiaStudies(id: string, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}studies/${id}`, data, {
      headers: {
        Authorization: 'Bearer ' + this.token,
      },
    });
  }

  deleteGuiaStudies(id: string): Observable<any> {
    return this.http.delete(`${environment.api_guia}studies/${id}`, {
      headers: {
        Authorization: 'Bearer ' + this.token,
      },
    });
  }

}
